<template>
  <span class="start">
    <template v-if="score > 0 && score <= 1">
        <i class="s bImg s1"></i><i class="n bImg n4"></i>
    </template>
    <template v-if="score > 1 && score <= 1.5">
        <i class="s bImg s1"></i><i class="s1-1"></i><i class="n bImg n3"></i>
    </template>
    <template v-if="score > 1 && score <= 2">
        <i class="s bImg s2"></i><i class="n bImg n3"></i>
    </template>
    <template v-if="score > 2 && score <= 2.5">
        <i class="s bImg s2"></i><i class="s1-1"></i><i class="n bImg n2"></i>
    </template>
    <template v-if="score > 2 && score <= 3">
        <i class="s bImg s3"></i><i class="n bImg n2"></i>
    </template>
    <template v-if="score > 3 && score <= 3.5">
        <i class="s bImg s3"></i><i class="s1-1"></i><i class="n bImg n1"></i>
    </template>
    <template v-if="score > 3 && score <= 4">
        <i class="s bImg s4"></i><i class="n bImg n1"></i>
    </template>
    <template v-if="score > 4 && score <= 4.5">
        <i class="s bImg s4"></i><i class="s1-1"></i>
    </template>
    <template v-if="score > 4 && score <= 5">
        <i class="s bImg s5"></i>
    </template>
  </span>
</template>
<script>
  export default{
    name:'score',
    props:['newscore'],
    data:function () {
      return{
        score:this.newscore
      }
    }
  }
</script>
<style scoped="">
  /*评论*/
   .start i.s{
    display:block;
    background:url(../../assets/images/new-detailicon-light.png) 0 0px;
    background-size: 16px 15px;
    float: left;
  }
   .start i.s.ret{
    background:url(../../assets/images/new-detailicon-light.png) 0 0px;
    background-size: 16px 15px;
  }
   .start .s1 {
    width:16px;
    height:15px;
  }
   .start .s2 {
    width:32px;
    height:15px;
  }
   .start .s3 {
    width:48px;
    height:15px;
  }
   .start .s4 {
    width:64px;
    height:15px;
  }
   .start .s5 {
    width:80px;
    height:15px;
  }
   .start i.n{
    display:block;
    background:url(../../assets/images/new-detailicon-normal.png) 0 0px;
    background-size: 16px 15px;
    float: left;
  }
   .start i.n.ret{
    background:url(../../assets/images/new-detailicon-normal.png) 0 0px;
    background-size: 16px 15px;
  }
   .start .n1 {
    width:15px;
    height:15px;
  }
   .start .n2 {
    width:32px;
    height:15px;
  }
   .start .n3 {
    width:50px;
    height:15px;
  }
   .start .n4 {
    width:70px;
    height:15px;
  }
   .start .n5 {
    width:85px;
    height:15px;
  }
   .start .s1-1 {
    float: left;
    width: 16px;
    height: 15px;
    display: block;
    background: url(../../assets/images/new-detailicon-light-half.png) no-repeat 0px 0px;
    background-size: 16px 15px;
  }
   .start .s1-1.ret {
    background: url(../../assets/images/new-detailicon-light-half.png) no-repeat 0px 0px;
    background-size: 16px 15px;
  }
</style>



// WEBPACK FOOTER //
// score.vue?0c5915a0